import { render, staticRenderFns } from "./ResetPassword.vue?vue&type=template&id=dd0150f2&scoped=true"
import script from "./ResetPassword.vue?vue&type=script&lang=js"
export * from "./ResetPassword.vue?vue&type=script&lang=js"
import style0 from "./ResetPassword.vue?vue&type=style&index=0&id=dd0150f2&prod&scoped=true&lang=css"
import style1 from "./ResetPassword.vue?vue&type=style&index=1&id=dd0150f2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd0150f2",
  null
  
)

export default component.exports